import React from 'react'
import AddQuickTalesToGAAlbumContainer from '../../modules/GAAlbums/containers/AddQuickTalesToGAAlbumContainer/AddQuickTalesToGAAlbumContainer'

const AddQuickTalesToGAAlbum = () => {
  return (
    <AddQuickTalesToGAAlbumContainer />
  )
}

export default AddQuickTalesToGAAlbum